import React from 'react'
import { Box, Divider, useTheme } from '@mui/material'
import SummaryItem from './SummaryItem'
import { CashAmount } from '../../../swagger'

interface FinancialSummaryProps {
  totalTutorsOwe: CashAmount
  totalDirectorOwe: CashAmount
  totalFamiliesOwe: CashAmount
}

const VerticalDivider = () => (
  <Divider orientation="vertical" flexItem sx={{ opacity: 0.3 }} />
)

const FinancialSummary: React.FC<FinancialSummaryProps> = ({
  totalTutorsOwe,
  totalDirectorOwe,
  totalFamiliesOwe,
}) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        mt: 1,
        justifyContent: 'flex-end',
        pr: 2,
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 1,
          pr: 0,
        },
      }}
    >
      <SummaryItem label="Director Owes CC" value={totalDirectorOwe} />
      <VerticalDivider />
      <SummaryItem label="Tutors Owe Director" value={totalTutorsOwe} />
      <VerticalDivider />
      <SummaryItem label="Families Owe Tutors" value={totalFamiliesOwe} />
    </Box>
  )
}

export default FinancialSummary
